import React from 'react';
import ReactPlayer from 'react-player/youtube';

import { Box, Container, Grid } from '@material-ui/core';

import { useIsDesktop } from '../hooks/useBreakpoints';
import { makeBlockStyles, useBlockStyles } from '../hooks/useStyles';
import { BlockBuilder, BlockVideo } from '../types/_blocks.types';

const useStyles = makeBlockStyles(() => ({
  root: {
    //
  },
}));

type Props = BlockBuilder<BlockVideo>;

export const VideoBlock: React.FC<Props> = ({ block }) => {
  const { url, platform } = block;
  const classes = useBlockStyles(useStyles, block);
  const isDesktop = useIsDesktop();
  if (platform !== 'youtube') {
    console.error('Only youtube support has currently been enabled');
  }
  return (
    <Box className={classes.boxBlock}>
      <Container className={classes.root}>
        <Grid container justifyContent="center">
          <Grid item xs={10}>
            <ReactPlayer
              url={url}
              style={{ margin: 'auto' }}
              {...(!isDesktop && { width: '100%' })}
            />
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};
